export const dummyFullAddress = {
  name: "",
  address: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  fax: "",
  email: "",
};

export const dummyProvider = {
  name_provider: "",
  search_name_provider: "",
  speciality_first_checkbox: [],
  speciality_second_checkbox: [],
  website: "",
  isSearchable: false,
  locations: [
    {
      id: 0,
      speciality_checkbox: [],
      fullAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        fax: "",
        email: "",
      },
    },
  ],
  recordRequest: { ...dummyFullAddress },
  billingRequest: { ...dummyFullAddress },
  payRecord: { ...dummyFullAddress },
  payBilling: { ...dummyFullAddress },
  lienHolder: { ...dummyFullAddress },
};
export const dummyProvidersData = [
  {
    name_provider: "Provider 1",
    search_name_provider: "Provider One",
    speciality_first_checkbox: ["Speciality 1", "Speciality 2"],
    speciality_second_checkbox: ["Speciality 3"],
    website: "http://provider1.com",
    isSearchable: true,
    locations: [
      {
        id: 1,

        fullAddress: {
          address: "123 Main St",
          address2: "Suite 100",
          city: "Anytown",
          state: "CA",
          zip: "12345",
          phone: "123-456-7890",
          fax: "123-456-7891",
          email: "contact@provider1.com",
        },
      },
    ],
    recordRequest: {
      name: "Provider 1 Records",
      fullAddress: {
        address: "456 Elm St",
        address2: "",
        city: "Othertown",
        state: "TX",
        zip: "67890",
        phone: "987-654-3210",
        fax: "987-654-3211",
        email: "records@provider1.com",
      },
    },
    billingRequest: {
      name: "Provider 1 Billing",
      fullAddress: {
        address: "789 Oak St",
        address2: "Apt 4B",
        city: "Elsewhere",
        state: "NY",
        zip: "11223",
        phone: "456-789-0123",
        fax: "456-789-0124",
        email: "billing@provider1.com",
      },
    },
    payRecord: {
      name: "Provider 1 Pay Records",
      fullAddress: {
        address: "321 Pine St",
        address2: "",
        city: "Somewhere",
        state: "FL",
        zip: "33445",
        phone: "321-654-9870",
        fax: "321-654-9871",
        email: "payrecords@provider1.com",
      },
    },
    payBilling: {
      name: "Provider 1 Pay Billing",
      fullAddress: {
        address: "654 Birch St",
        address2: "Unit 12",
        city: "Here",
        state: "NV",
        zip: "55667",
        phone: "654-321-0987",
        fax: "654-321-0988",
        email: "paybilling@provider1.com",
      },
    },
    lienHolder: {
      name: "Provider 1 Lien Holder",
      fullAddress: {
        address: "987 Cedar St",
        address2: "",
        city: "There",
        state: "AZ",
        zip: "77889",
        phone: "789-012-3456",
        fax: "789-012-3457",
        email: "lienholder@provider1.com",
      },
    },
  },
  {
    name_provider: "Provider 2",
    search_name_provider: "Provider Two",
    speciality_first_checkbox: ["Speciality 2", "Speciality 4"],
    speciality_second_checkbox: ["Speciality 1"],
    website: "http://provider2.com",
    isSearchable: false,
    locations: [
      {
        id: 2,

        fullAddress: {
          address: "222 Maple St",
          address2: "",
          city: "Newtown",
          state: "NJ",
          zip: "22456",
          phone: "222-333-4444",
          fax: "222-333-4445",
          email: "contact@provider2.com",
        },
      },
    ],
    recordRequest: {
      name: "Provider 2 Records",
      fullAddress: {
        address: "333 Spruce St",
        address2: "Floor 3",
        city: "Oldtown",
        state: "OR",
        zip: "33567",
        phone: "333-444-5555",
        fax: "333-444-5556",
        email: "records@provider2.com",
      },
    },
    billingRequest: {
      name: "Provider 2 Billing",
      fullAddress: {
        address: "444 Aspen St",
        address2: "",
        city: "Ville",
        state: "WA",
        zip: "44678",
        phone: "444-555-6666",
        fax: "444-555-6667",
        email: "billing@provider2.com",
      },
    },
    payRecord: {
      name: "Provider 2 Pay Records",
      fullAddress: {
        address: "555 Redwood St",
        address2: "Suite 5",
        city: "Metro",
        state: "CO",
        zip: "55789",
        phone: "555-666-7777",
        fax: "555-666-7778",
        email: "payrecords@provider2.com",
      },
    },
    payBilling: {
      name: "Provider 2 Pay Billing",
      fullAddress: {
        address: "666 Willow St",
        address2: "",
        city: "Hamlet",
        state: "GA",
        zip: "66890",
        phone: "666-777-8888",
        fax: "666-777-8889",
        email: "paybilling@provider2.com",
      },
    },
    lienHolder: {
      name: "Provider 2 Lien Holder",
      fullAddress: {
        address: "777 Palm St",
        address2: "Unit 2",
        city: "Place",
        state: "MO",
        zip: "77901",
        phone: "777-888-9999",
        fax: "777-888-9990",
        email: "lienholder@provider2.com",
      },
    },
  },
  {
    name_provider: "Provider 3",
    search_name_provider: "Provider Three",
    speciality_first_checkbox: ["Speciality 1"],
    speciality_second_checkbox: ["Speciality 3", "Speciality 4"],
    website: "http://provider3.com",
    isSearchable: true,
    locations: [
      {
        id: 3,

        fullAddress: {
          address: "888 Chestnut St",
          address2: "",
          city: "Uptown",
          state: "MN",
          zip: "88012",
          phone: "888-999-0000",
          fax: "888-999-0001",
          email: "contact@provider3.com",
        },
      },
    ],
    recordRequest: {
      name: "Provider 3 Records",
      fullAddress: {
        address: "999 Oakwood St",
        address2: "",
        city: "Downtown",
        state: "WI",
        zip: "99023",
        phone: "999-000-1111",
        fax: "999-000-1112",
        email: "records@provider3.com",
      },
    },
    billingRequest: {
      name: "Provider 3 Billing",
      fullAddress: {
        address: "111 Pineapple St",
        address2: "",
        city: "Midtown",
        state: "TN",
        zip: "11134",
        phone: "000-111-2222",
        fax: "000-111-2223",
        email: "billing@provider3.com",
      },
    },
    payRecord: {
      name: "Provider 3 Pay Records",
      fullAddress: {
        address: "222 Grape St",
        address2: "",
        city: "Suburb",
        state: "NC",
        zip: "22245",
        phone: "111-222-3333",
        fax: "111-222-3334",
        email: "payrecords@provider3.com",
      },
    },
    payBilling: {
      name: "Provider 3 Pay Billing",
      fullAddress: {
        address: "333 Melon St",
        address2: "",
        city: "Borough",
        state: "SC",
        zip: "33356",
        phone: "222-333-4444",
        fax: "222-333-4445",
        email: "paybilling@provider3.com",
      },
    },
    lienHolder: {
      name: "Provider 3 Lien Holder",
      fullAddress: {
        address: "444 Banana St",
        address2: "",
        city: "Town",
        state: "LA",
        zip: "44467",
        phone: "333-444-5555",
        fax: "333-444-5556",
        email: "lienholder@provider3.com",
      },
    },
  },
  {
    name_provider: "Provider 5",
    search_name_provider: "Provider Five",
    speciality_first_checkbox: ["Speciality 3"],
    speciality_second_checkbox: ["Speciality 2"],
    website: "http://provider5.com",
    isSearchable: true,
    locations: [
      {
        id: 5,

        fullAddress: {
          address: "555 Elm St",
          address2: "Suite 200",
          city: "Greenfield",
          state: "MA",
          zip: "01234",
          phone: "555-123-4567",
          fax: "555-123-4568",
          email: "contact@provider5.com",
        },
      },
    ],
    recordRequest: {
      name: "Provider 5 Records",
      fullAddress: {
        address: "666 Oak St",
        address2: "",
        city: "Springfield",
        state: "IL",
        zip: "56789",
        phone: "666-234-5678",
        fax: "666-234-5679",
        email: "records@provider5.com",
      },
    },
    billingRequest: {
      name: "Provider 5 Billing",
      fullAddress: {
        address: "777 Maple St",
        address2: "Apt 6B",
        city: "Columbus",
        state: "OH",
        zip: "67890",
        phone: "777-345-6789",
        fax: "777-345-6790",
        email: "billing@provider5.com",
      },
    },
    payRecord: {
      name: "Provider 5 Pay Records",
      fullAddress: {
        address: "888 Birch St",
        address2: "",
        city: "Madison",
        state: "WI",
        zip: "78901",
        phone: "888-456-7890",
        fax: "888-456-7891",
        email: "payrecords@provider5.com",
      },
    },
    payBilling: {
      name: "Provider 5 Pay Billing",
      fullAddress: {
        address: "999 Pine St",
        address2: "Unit 7",
        city: "Charleston",
        state: "SC",
        zip: "89012",
        phone: "999-567-8901",
        fax: "999-567-8902",
        email: "paybilling@provider5.com",
      },
    },
    lienHolder: {
      name: "Provider 5 Lien Holder",
      fullAddress: {
        address: "1000 Cedar St",
        address2: "",
        city: "Atlanta",
        state: "GA",
        zip: "90123",
        phone: "1000-678-9012",
        fax: "1000-678-9013",
        email: "lienholder@provider5.com",
      },
    },
  },
  {
    name_provider: "Provider 6",
    search_name_provider: "Provider Six",
    speciality_first_checkbox: ["Speciality 4"],
    speciality_second_checkbox: ["Speciality 3"],
    website: "http://provider6.com",
    isSearchable: true,
    locations: [
      {
        id: 6,

        fullAddress: {
          address: "1010 Maple Ave",
          address2: "",
          city: "Raleigh",
          state: "NC",
          zip: "23456",
          phone: "1010-789-0123",
          fax: "1010-789-0124",
          email: "contact@provider6.com",
        },
      },
    ],
    recordRequest: {
      name: "Provider 6 Records",
      fullAddress: {
        address: "1212 Cedar Ave",
        address2: "Suite 300",
        city: "Durham",
        state: "NC",
        zip: "34567",
        phone: "1212-890-1234",
        fax: "1212-890-1235",
        email: "records@provider6.com",
      },
    },
    billingRequest: {
      name: "Provider 6 Billing",
      fullAddress: {
        address: "1313 Oak Ave",
        address2: "",
        city: "Chapel Hill",
        state: "NC",
        zip: "45678",
        phone: "1313-901-2345",
        fax: "1313-901-2346",
        email: "billing@provider6.com",
      },
    },
    payRecord: {
      name: "Provider 6 Pay Records",
      fullAddress: {
        address: "1414 Birch Ave",
        address2: "Apt 8C",
        city: "Greensboro",
        state: "NC",
        zip: "56789",
        phone: "1414-012-3456",
        fax: "1414-012-3457",
        email: "payrecords@provider6.com",
      },
    },
    payBilling: {
      name: "Provider 6 Pay Billing",
      fullAddress: {
        address: "1515 Elm Ave",
        address2: "",
        city: "Wilmington",
        state: "NC",
        zip: "67890",
        phone: "1515-123-4567",
        fax: "1515-123-4568",
        email: "paybilling@provider6.com",
      },
    },
    lienHolder: {
      name: "Provider 6 Lien Holder",
      fullAddress: {
        address: "1616 Pine Ave",
        address2: "Unit 9",
        city: "Fayetteville",
        state: "NC",
        zip: "78901",
        phone: "1616-234-5678",
        fax: "1616-234-5679",
        email: "lienholder@provider6.com",
      },
    },
  },
  {
    name_provider: "Provider 7",
    search_name_provider: "Provider Seven",
    speciality_first_checkbox: ["Speciality 1", "Speciality 3"],
    speciality_second_checkbox: ["Speciality 4"],
    website: "http://provider7.com",
    isSearchable: false,
    locations: [
      {
        id: 7,

        fullAddress: {
          address: "1717 Elm St",
          address2: "",
          city: "Des Moines",
          state: "IA",
          zip: "67890",
          phone: "1717-345-6789",
          fax: "1717-345-6790",
          email: "contact@provider7.com",
        },
      },
    ],
    recordRequest: {
      name: "Provider 7 Records",
      fullAddress: {
        address: "1818 Maple St",
        address2: "Suite 400",
        city: "Cedar Rapids",
        state: "IA",
        zip: "78901",
        phone: "1818-456-7890",
        fax: "1818-456-7891",
        email: "records@provider7.com",
      },
    },
    billingRequest: {
      name: "Provider 7 Billing",
      fullAddress: {
        address: "1919 Oak St",
        address2: "",
        city: "Davenport",
        state: "IA",
        zip: "89012",
        phone: "1919-567-8901",
        fax: "1919-567-8902",
        email: "billing@provider7.com",
      },
    },
    payRecord: {
      name: "Provider 7 Pay Records",
      fullAddress: {
        address: "2020 Pine St",
        address2: "Apt 10D",
        city: "Iowa City",
        state: "IA",
        zip: "90123",
        phone: "2020-678-9012",
        fax: "2020-678-9013",
        email: "payrecords@provider7.com",
      },
    },
    payBilling: {
      name: "Provider 7 Pay Billing",
      fullAddress: {
        address: "2121 Cedar St",
        address2: "",
        city: "Marshalltown",
        state: "IA",
        zip: "01234",
        phone: "2121-789-0123",
        fax: "2121-789-0124",
        email: "paybilling@provider7.com",
      },
    },
    lienHolder: {
      name: "Provider 7 Lien Holder",
      fullAddress: {
        address: "2222 Birch St",
        address2: "Unit 11",
        city: "Ames",
        state: "IA",
        zip: "12345",
        phone: "2222-890-1234",
        fax: "2222-890-1235",
        email: "lienholder@provider7.com",
      },
    },
  },
];
